module.exports = __webpack_public_path__ + "img/fl_s.2eae7983.png";